// Third-party
import React, { useState, useEffect } from 'react';

// Components
import { CloseButton, PrimaryButton } from '@/views/components/buttons';
import ErrorLogTable from '@/views/containers/admin/admin-portal/ErrorLogTable';
import Modal from '@/views/components/modals/AccessibleModal';

// Types
import { DataUploadPortalConfig, DataUploadPortalLog } from '@/types/data-upload-config';
import Locale from '@/types/locale';

// Utils
import { formatMessage } from '@/utils/i18n';

type Props = {
  config: DataUploadPortalConfig;
  locale?: Locale;
  show: boolean;
  onCancel: () => void;
  showFileUpload: () => void;
};

const ErrorLogModal: React.FC<Props> = (props: Props) => {
  const { config, show, onCancel, showFileUpload } = props;

  const [logs, setLogs] = useState<Array<DataUploadPortalLog>>([]);

  useEffect(() => {
    const { dataUpload } = config;
    if (dataUpload && dataUpload.validationLog) {
      setLogs(dataUpload.validationLog);
    }
  }, [config]);

  const onReupload = () => {
    onCancel();
    showFileUpload();
  };

  return (
    <Modal show={show} onHide={onCancel} className="error-log-modal-container" dialogClassName="modal-dialog-centered">
      <Modal.Header>
        <Modal.Title>
          <i className="icon-exclamation-outline" />
          <span>
            {formatMessage('Admin.DataUpload.ErrorLog.Title', {
              errors: logs.length,
            })}
          </span>
        </Modal.Title>
        {!!onCancel && <CloseButton onClick={onCancel} />}
      </Modal.Header>
      <Modal.Body>
        <ErrorLogTable config={config} />
      </Modal.Body>
      <Modal.Footer>
        <PrimaryButton onClick={onReupload} className="re-upload-button">
          {formatMessage('Admin.DataUpload.ErrorLog.ReUpload')}
        </PrimaryButton>
      </Modal.Footer>
    </Modal>
  );
};

export default ErrorLogModal;
